import React from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import { LastLocationProvider } from 'react-router-last-location';
import { PrivateRoute, PublicRoute, AdminRoute } from './components';

import { ExternalContentsPage } from './containers/ExternalContentsPage';
import { ExternalContentsForm } from './containers/ExternalContentsForm';
import { LoginPage } from './containers/LoginPage';
import { LogoutPage } from './containers/LogoutPage';
import { DashboardPage } from './containers/DashboardPage';
import { HomePage } from './containers/HomePage';
import { IdeaPage } from './containers/IdeaPage';
import { IdeaPointPage } from './containers/IdeaPointPage';
import { PerfilPage } from './containers/PerfilPage';
import { SettingsPage } from './containers/SettingsPage';
import { IdeaEditPage } from './containers/IdeaEditPage';
import { IdeaCanvasPage } from './containers/IdeaCanvasPage';
import { RegisterPage } from './containers/RegisterPage';
import { ProfilePage } from './containers/ProfilePage';
import { WalletPage } from './containers/WalletPage';
import { RankingPage } from './containers/RankingPage';
import { ContentsPage } from './containers/ContentsPage';
import { ChallengePage } from './containers/ChallengePage';
import { ChallengeNewPage } from './containers/ChallengeNewPage';
import { ChallengeDetailPage } from './containers/ChallengeDetailPage';
import { ChallengeEditPage } from './containers/ChallengeEditPage';
import { ManagerRoute } from './components/Routes/ManagerRoute';
import { RecoverPasswordPage } from './containers/RecoverPasswordPage';
import { ResetPasswordPage } from './containers/ResetPasswordPage';
import { UsersPage } from './containers/UsersPage'
import { UserFunctionPage } from "./containers/UserFunctionPage"
import { RegulationPage } from './containers/RegulationPage';
import { HelpCenterPage } from './containers/HelpCenterPage';
import { TermsPage } from   './containers/TermsPage';
import { InviteLeadershipPage } from   './containers/InviteLeadership';
import { InvitePage } from   './containers/Invite';
import { ContentsDetailsPage } from './containers/ContentsDetailsPage';
import { PremiarPage } from './containers/PremiarPage';
import { ReportStatusIdea } from "./containers/ReportStatusIdea"
import { ReportStatusIdeaPendingManagers } from "./containers/ReportStatusIdeaPendingManagers"
import { ReportCustoRetorno } from "./containers/ReportCustoRetorno"
import { ReportColaborator } from "./containers/ReportColaborator"
import { CurationIdeasMatPage } from './containers/CurationIdeasMatPage';
import { IdeaDetailsPage } from "./containers/IdeaDetailsPage";
import { FaqPage } from "./containers/FaqPage";
import { AdminUserEditPage } from "./containers/AdminUserEditPage";
import { UserPoints } from "./containers/UserPoints"; 
import { InfraestructurePage } from "./containers/InfraestructurePage";
import { PersonalizedClassificationPage } from "./containers/PersonalizedClassificationPage";
import { PersonalizedClassificationListPage } from "./containers/PersonalizedClassificationListPage";
import { TemplateCrudEditPage } from './containers/TemplateCrudEditPage';
import { TemplateCrudNewPage } from './containers/TemplateCrudNewPage';
import { TemplateCrudPage } from './containers/TemplateCrudPage';
import { ReportAccessColaborator } from './containers/ReportAccessColaborator';
import { ReportManager } from './containers/ReportManager/ReportManager';
import { PortfolioPage } from "./containers/PortfolioPage"
import { PortfolioDetailsPage } from "./containers/PortfolioDetailsPage"

function Routes() {
  return (
    <LastLocationProvider>
    <Switch>
        <PrivateRoute exact path="/crud/:name" component={TemplateCrudPage} />
        {/* <PrivateRoute exact path="/template-crud/new" component={TemplateCrudNewPage} />
        <PrivateRoute exact path="/template-crud/:id" component={TemplateCrudEditPage} /> */}
      <PrivateRoute exact path="/" component={HomePage} />
      <PrivateRoute path="/idea/point" component={IdeaPointPage} />
        <PrivateRoute path="/idea/:id/:page" exact component={IdeaDetailsPage} />
      <PrivateRoute path="/idea/:id/canvas" exact component={IdeaCanvasPage} />
      <ManagerRoute path="/curation" exact component={CurationIdeasMatPage} />
        <PrivateRoute path="/portfolio" exact component={PortfolioPage} />
        <PrivateRoute path="/portfolio/:id" exact component={PortfolioDetailsPage} />
        <PrivateRoute path="/my-ideas" exact component={IdeaPage} />
        <PrivateRoute path="/idea-edit/:id" exact component={IdeaEditPage} />
      <PrivateRoute path="/user/edit" exact component={PerfilPage} />
      <PrivateRoute path="/user/settings"  exact component={SettingsPage} />
      <PrivateRoute path="/profile/:id" component={ProfilePage} />
      <PrivateRoute path="/wallet/:id" component={WalletPage} />
      <PrivateRoute path="/ranking" component={RankingPage} />
      <PrivateRoute path="/contents" component={ContentsPage} />
      <PrivateRoute path="/contents-details" component={ContentsDetailsPage} />
      <PrivateRoute path="/premiar-page" component={PremiarPage} />
      <AdminRoute path="/external-contents" component={ExternalContentsPage} />
      <AdminRoute path="/external-content/new" component={ExternalContentsForm} />
      <AdminRoute path="/external-content/edit/:id" component={ExternalContentsForm} />
        <AdminRoute path="/infrastructure" exact component={InfraestructurePage} />
      <PrivateRoute path="/challenges" component={ChallengePage} />
        <PrivateRoute path="/users" exact component={UsersPage} />
        <PrivateRoute path="/users/function/:id" exact component={UserFunctionPage} />
        <AdminRoute path="/users/edit/:id" exact component={AdminUserEditPage} />
        <AdminRoute path="/users/points/:id" exact component={UserPoints} />
      <PrivateRoute path="/help-center" component={HelpCenterPage} />
      <PrivateRoute path="/faq" component={FaqPage} />
      <PrivateRoute path="/challenge/detail/:id" exact component={ChallengeDetailPage} />
      <AdminRoute path="/challenge/new" exact component={ChallengeNewPage} />
      <AdminRoute path="/challenge/edit/:id" exact component={ChallengeEditPage} />
      <PublicRoute path="/confirm-password-recover" component={ResetPasswordPage} />
      <PublicRoute path="/password-recover" component={RecoverPasswordPage} />
      <ManagerRoute path="/report/ideas-status" exact  component={ReportStatusIdea} />
        <ManagerRoute path="/report/ideas-status-pending-managers" exact component={ReportStatusIdeaPendingManagers} />
      <ManagerRoute path="/report/ideas-financial-return" exact component={ReportCustoRetorno} />
      <ManagerRoute path="/report/colaborator" exact component={ReportColaborator} />
        <ManagerRoute path="/report/colaborator-access" exact component={ReportAccessColaborator} />
        <ManagerRoute path="/preferences/personalized-classification" exact component={PersonalizedClassificationListPage} />
        <ManagerRoute path="/preferences/personalized-classification/edit" exact component={PersonalizedClassificationPage} />
        <ManagerRoute path="/report/managers-list" exact component={ReportManager} />
      <Route path="/regulation" component={RegulationPage} />
      <Route path="/terms" component={TermsPage} />
      <AdminRoute path="/dashboard"  exact component={DashboardPage} />
      <PublicRoute path="/register" exact component={RegisterPage} />
      <PublicRoute path="/login" component={LoginPage} />
      
      <PublicRoute path="/convitelideres"  component={InviteLeadershipPage} exact/>
        <PublicRoute path="/convite" component={InvitePage} exact />
      <PrivateRoute path="/logout" component={LogoutPage} />
      <Redirect from="*" to="/" />
    </Switch>
    </LastLocationProvider>
  );
}

export { Routes };
